import { account } from '../core/account.js';
import { firstScreen } from './start.js';
import { profiles } from '../core/profiles.js';
import { t } from '../core/i18n.js';
import { notify } from '../core/notify.js';
import { pageHead } from '../ui/render.js';

/* Página del móvil/ordenador para vincular una TV: introduce el código que muestra la TV. */

export default {
    path: '/pair/',
    nav: 'settings',

    render() {
        return `<div class="page" data-name="pair"><div class="page-content">
            ${pageHead({ title: t('pair.title') })}
            <div class="pair-form">
                <p class="text-2">${t('pair.hint')}</p>
                <form data-form novalidate>
                    <input class="pair-input" name="code" maxlength="7" autocomplete="one-time-code" autocapitalize="characters" spellcheck="false" placeholder="ABC123" data-nav-default/>
                    <div class="field-error" data-error hidden></div>
                    <button type="submit" class="btn btn-accent btn-lg btn-block" data-submit><span class="mi">link</span>${t('pair.button')}</button>
                </form>
            </div>
        </div></div>`;
    },

    mount(page) {
        const root = page.el;
        if (!account.signedIn) {
            window.app.views.main.router.navigate('/login/', { reloadAll: true });
            return () => {};
        }
        const form = root.querySelector('[data-form]');
        const input = form.code;
        const errorEl = root.querySelector('[data-error]');
        const submit = root.querySelector('[data-submit]');
        const params = new URLSearchParams(location.search);
        const preset = (params.get('code') || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 6);
        if (preset) {
            input.value = preset;
            if (history.replaceState) history.replaceState(null, '', '/pair');
        }
        setTimeout(() => (preset ? submit : input).focus(), 200);

        input.addEventListener('input', () => {
            input.value = input.value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 6);
            errorEl.hidden = true;
        });

        form.addEventListener('submit', async (e) => {
            e.preventDefault();
            const code = input.value.trim();
            if (code.length !== 6) {
                errorEl.textContent = t('pair.error');
                errorEl.hidden = false;
                return;
            }
            submit.disabled = true;
            try {
                await account.claimPairing(code);
                notify.toast(t('pair.success'), { icon: 'check_circle', duration: 3500 });
                input.value = '';
                if (profiles.current()) window.IPTV.back();
                else window.app.views.main.router.navigate(firstScreen({ needsAccount: account.enabled && !account.signedIn }), { reloadAll: true, clearPreviousHistory: true });
            } catch (err) {
                errorEl.textContent = err.status === 404 ? t('pair.error') : t('common.errorNetwork');
                errorEl.hidden = false;
            } finally {
                submit.disabled = false;
            }
        });
        return () => {};
    }
};
